const env = {
  gitdashBaseUrl: process.env.REACT_APP_GITDASH_BASE_URL,
  gitdashUsersUrl: process.env.REACT_APP_GITDASH_USERS_URL,
  gitdashApiKey: process.env.REACT_APP_GITDASH_API_KEY,
  gitlabBaseUrl: process.env.REACT_APP_GITLAB_BASE_URL,
  timezone: process.env.REACT_APP_TIMEZONE || "Asia/Kolkata",
  logoUrl: process.env.REACT_APP_LOGO_URL,
  faviconUrl: process.env.REACT_APP_FAVICON_URL,
};

export default env;
